import { useAuth0 } from '@auth0/auth0-react';
import LoginIcon from '@mui/icons-material/Login';
import { Box, Button, Stack } from '@mui/material';
import React from 'react';

import bannerImage from '../assets/okvc-people-banner.png';

const Login = () => {
  const { loginWithRedirect } = useAuth0();

  return (
    <Box sx={{ display: 'flex' }}>
      <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
        <Stack spacing={2}>
          <h2>Welcome to the Care Center</h2>
          <img src={bannerImage} alt="Elderly people smiling" width="1000px" />
          <Box>
            <Button variant="contained" startIcon={<LoginIcon />} onClick={() => loginWithRedirect()} size="large">
              Log in
            </Button>
          </Box>
        </Stack>
      </Box>
    </Box>
  );
};

export default Login;
